import reg from '@/utils/reg.js'

const getInput = (ele) => {
  for (var i = 0; i < ele.children.length; i++) {
    var item = ele.children[i]
    if (item.className && item.className.indexOf('el-input__inner') > -1) {
      return item
    }
  }
}

export default {
  bind (el, binding, vnode) {
    const opts = Object.assign({}, {
      ele: el,
      type: binding.arg ? binding.arg : 'number'
    })
    opts.ele.onkeydown = (e) => {
      return e.key !== 'Process' && !e.shiftKey && (!isNaN(e.key) || ['.', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].indexOf(e.key) > -1)
    }
    opts.ele.onkeyup = (e) => {
      let input = getInput(opts.ele)
      let _reg = reg[opts.type]
      if (input && _reg && !_reg.test(input.value)) {
        input.style.borderColor = 'red'
      } else {
        input.style.borderColor = ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/reg-input.js